import React from 'react';
import PropTypes from 'prop-types';
import FieldCurrencyInput from '../FieldCurrencyInput/FieldCurrencyInput';
import css from './MinMaxCurrencyInput.module.css';
import appSettings from '../../config/settings';
import Chevron from '../Chevron/Chevron';
import { required, composeValidators, moneySubUnitAmountAtLeast } from '../../util/validators';
import classNames from 'classnames';

const MinMaxCurrencyInput = ({
  sectionTitle,
  label,
  name,
  value,
  minLabel = 'Minimum Value',
  maxLabel = 'Maximum Value',
  userCurrency,
  showChevron = false,
  required: isRequired = false,
}) => {
    const currencyConfig = appSettings.getCurrencyFormatting(userCurrency);

  const [expanded, setExpanded] = React.useState(false);

  return (
    <div className={css.container}>
      <div className={css.headerRow}>
        <div>
          <span className={css.sectionTitle}>{sectionTitle}</span>
          <div className={css.sectionDesc}>{label} {isRequired && <span className={css.required}>*</span>}</div>
        </div>
        {showChevron && <button
          type="button"
          className={css.chevronBtn}
          onClick={() => setExpanded(e => !e)}
          aria-label={expanded ? 'Collapse' : 'Expand'}
        >
          <Chevron expanded={expanded} width={20} height={20} />
        </button>}
      </div>
      <div className={classNames(css.fieldsRow, expanded ? css.expanded : css.collapsed)}>
        <div className={css.inputGroup}>
          <FieldCurrencyInput
            name={`${name}.min`}
            id={`${name}_min`}
            label={minLabel}
            validate={composeValidators(
              required('Minimum value is required'),
              moneySubUnitAmountAtLeast('Minimum value must be positive', 1)
            )}
            currencyConfig={currencyConfig}
          />
        </div>
        <div className={css.inputGroup}>
          <FieldCurrencyInput
            name={`${name}.max`}
            id={`${name}_max`}
            label={maxLabel}
            validate={composeValidators(
              required('Maximum value is required'),
              moneySubUnitAmountAtLeast('Maximum value must be positive', 1)
            )}
            currencyConfig={currencyConfig}
          />
        </div>
      </div>
    </div>
  );
};

MinMaxCurrencyInput.propTypes = {
  name: PropTypes.string.isRequired,
  sectionTitle: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  minValidator: PropTypes.func,
  maxValidator: PropTypes.func,
  minLabel: PropTypes.string,
  maxLabel: PropTypes.string,
  value: PropTypes.shape({
    min: PropTypes.string,
    max: PropTypes.string,
  }),
  userCurrency: PropTypes.string.isRequired,
  required: PropTypes.bool,
};

export default MinMaxCurrencyInput;
